<template>
  <v-layout row wrap justify-center>
    <v-flex xs12 sm6 md3> 
      <div v-if="canDownloadOperation && operation.authPolicy">
        <div v-for="(field, index) in operation.authPolicy.fields" :key="`field-${index}`" v-if="field.resumen === 'Y' && field.label !== ''">
            <v-text-field class="font-weight-medium" type="text" v-model="field.value" :label="field.label" disabled="true" outline></v-text-field>
        </div>
      </div>
      <p class="esign-error-text" v-if="operationUuidMsg">El operation uuid es un campo obligatorio para conseguir los datos de la operación.</p>
      <p class="esign-error-text" v-if="domainUuidMsg">El identificador del dominio es un campo obligatorio para pedir los datos de la operación.</p>
      <p id="snackbar-success"></p>
      <p id="snackbar-error"></p>
     </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  props: {
    token: String,
    endPoint: String,
    domainUuid: String,
    operationUuid: String,
    status: {
      type: Number,
      default: 0
    },
    response: {
      type: String,
      default: ""
    },
    loading: Boolean,
    snackBar: Boolean,
    successMsg: String,
    errorMsg: String
  },
  data() {
    return {
      domainUuidMsg: false,
      operationUuidMsg: false,
      operation: {},
      canDownloadOperation: true
    };
  },
  created() {
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.domainUuidMsg =
      (typeof this.domainUuid === "undefined" || this.domainUuid === "") ===
      true;
    if (this.operationUuidMsg === true || this.domainUuidMsg === true) {
      this.canDownloadOperation = false;
    } else {
      this.getOperationByUuid();
    }
  },
  methods: {
    getOperationByUuid() {
      axios.defaults.headers.common.Authorization = this.token;
      if (this.loading) {
        this.showLoading();
      }
      this.EventBus.$emit("notifyGetOperation", "showLoading");
      axios
        .get(`${this.endPoint}${this.domainUuid}${"/"}${this.operationUuid}`, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (this.loading) {
              this.hideLoading();
            }
            this.operation = responseSuccess.data;
            if (this.snackBar) {
              this.$showSnackBar("snackbar-success", this.successMsg);
            }
            this.EventBus.$emit("notifyGetOperation", "hideLoading");
            this.EventBus.$emit("successGetOperation");
          },
          () => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-error", this.errorMsg);
            }
            this.EventBus.$emit("notifyGetOperation", "hideLoading");
            this.EventBus.$emit("errorGetOperation");
          }
        );
    }
  }
};
</script>
